import { css } from 'styled-system/css';

export function NativeFormula({ compact }: { compact?: boolean }) {
  const fn = compact ? undefined : css({ color: '#a78bfa' });
  const ref = compact ? undefined : css({ color: '#7ab8f0' });
  const muted = compact ? undefined : css({ color: 'text.muted' });
  const num = compact ? undefined : css({ color: '#86efac' });
  const gap = compact ? null : '\n  ';
  const nest = compact ? null : '\n    ';
  const deep = compact ? null : '\n      ';
  const endDeep = compact ? null : '\n    ';
  const endNest = compact ? null : '\n  ';
  const end = compact ? null : '\n';
  const comma = compact ? ', ' : ',';

  return (
    <>
      <span className={fn}>=IFERROR</span>
      <span className={muted}>(</span>
      {gap}
      <span className={fn}>NPV</span>
      <span className={muted}>(</span>
      {nest}
      <span className={fn}>XLOOKUP</span>
      <span className={muted}>(</span>
      {deep}
      <span className={ref}>A4</span>
      <span className={muted}>{comma}</span>
      {deep}
      <span className={ref}>Rates[Ticker]</span>
      <span className={muted}>{comma}</span>
      {deep}
      <span className={ref}>Rates[WACC]</span>
      {endDeep}
      <span className={muted}>)</span>
      <span className={muted}>{comma}</span>
      {nest}
      <span className={ref}>Cashflows[Amount]</span>
      {endNest}
      <span className={muted}>)</span>
      <span className={muted}>{comma}</span>
      {gap}
      <span className={num}>0</span>
      {end}
      <span className={muted}>)</span>
    </>
  );
}
